import { ResourceCrudPage } from '@/components/crud/ResourceCrudPage'

export function ActivityPage() {
  return (
    <ResourceCrudPage
      resource="super_agents__agentrun"
      title="Activity"
      description="Every piece of work an agent did: what started it, each step, what it cost."
    />
  )
}

export function SchedulesPage() {
  return (
    <ResourceCrudPage
      resource="super_agents__routine"
      title="Simple schedules"
      description="One agent, one job, on a schedule or when something happens. For anything with more steps, use a workflow."
    />
  )
}
